import { Box } from "@govlaunch/web";
import React from "react";
import { ICardViewMode } from "~/src/components/collection/cardViewMode";
import { FormattedMessage } from "react-intl";

interface ICollectionCardNewContentProps {
  viewMode?: ICardViewMode;
}

export default function CollectionCardNewContent({ viewMode = ICardViewMode.Singles }: ICollectionCardNewContentProps) {
  return (
    <Box
      position="absolute"
      bottom="8px"
      left="8px"
      color="red.800"
      fontSize={["lg", "sm", "md", "md"]}
      fontWeight="semibold"
      maxWidth={viewMode === ICardViewMode.Singles || viewMode === ICardViewMode.MyCollections ? "90px" : undefined}
    >
      &#x25B8; <FormattedMessage defaultMessage="New Content" id="6aSEZT" />
    </Box>
  );
}
